import pathfinder from '@fiverr-private/pathfinder';
import { getDefaultLocaleValue } from '../../../../shared/utils';
import { PATHS, PATHFINDER } from '../../constants';

export const getSubCategoryPath = ({ categoryId, id }, source) => {
    if (!(categoryId && id)) {
        return PATHS.ROOT;
    }

    if (isNaN(parseInt(categoryId, 10)) || isNaN(parseInt(id, 10))) {
        return PATHS.ROOT;
    }

    const categorySlug = getDefaultLocaleValue(`categories.category_${categoryId}.cached_slug`);
    const subCategorySlug = getDefaultLocaleValue(`sub_categories.sub_category_${id}.cached_slug`);
    const params = {
        category_id: categorySlug,
        id: subCategorySlug
    };

    const options = { query: { source } };

    return (categorySlug && subCategorySlug) ? pathfinder(PATHFINDER.SUB_CATEGORY, params, options) : '';
};
